var map = {
	"./1.jpeg": 8520,
	"./10.jpeg": 1448,
	"./11.jpeg": 9967,
	"./2.jpeg": 6665,
	"./3.jpeg": 5810,
	"./4.jpeg": 7424,
	"./5.jpeg": 2764,
	"./6.jpeg": 5645,
	"./7.jpeg": 6982,
	"./8.jpeg": 9623,
	"./9.jpeg": 8800
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 638;